
class SearchTrigger extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('[data-trigger]');
    this.searchBar = document.getElementById('search-bar');
    this.isMobile = new DeviceWidth().isMobile;
  }
  connectedCallback() {
    this.trigger.addEventListener('click', (event) => {
      event.preventDefault();
      const searchForm = document.querySelector('.search-modal__form')
      this.searchBar.querySelector('details').setAttribute('open', true);
      setTimeout(() => {
        searchForm.querySelector('input[type="search"]').focus();
      }, 0)
    });

    this.searchBar.querySelector('details').addEventListener('toggle', () => {
      if(this.isMobile || !document.body.classList.contains('gender-generic')) return;
      const style = window.getComputedStyle(this.searchBar);
      this.searchBar.style.display = style.display === 'none' ? 'flex' : 'none';
    })
  }
  
}

customElements.define('search-trigger', SearchTrigger);